// material-ui

import SimpleBar from 'components/third-party/SimpleBar';
import Navigation from './Navigation';

// project import

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  return (
    <SimpleBar
      sx={{
        height: { xs: 'calc(100vh - 70px)', md: 'calc(100% - 70px)' },
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column',
        }
      }}
    >
      <Navigation />
    </SimpleBar>
  );
};

export default DrawerContent;
